const Splash = () =>
  import(/* webpackChunkName: "cms-splash" */ '@/pages/cms/content/splash')
const CreateSplash = () =>
  import(
    /* webpackChunkName: "cms-splash" */ '@/pages/cms/content/splash/create.vue'
  )
const EditSplash = () =>
  import(
    /* webpackChunkName: "cms-splash" */ '@/pages/cms/content/splash/edit.vue'
  )

export default {
  path: 'splash',
  meta: {
    label: 'splash',
    auth: 'splash'
  },
  component: {
    name: 'Splash',
    render(c) {
      return c('router-view')
    }
  },
  children: [
    {
      name: 'CmsSplashReport',
      path: '',
      meta: {
        label: 'report',
        auth: 'report'
      },
      component: Splash
    },
    {
      name: 'CmsCreateSplash',
      path: 'create',
      meta: {
        label: 'create',
        auth: 'create'
      },
      component: CreateSplash
    },
    {
      name: 'CmsEditSplash',
      path: 'edit/:id',
      meta: {
        label: 'edit',
        auth: 'update'
      },
      component: EditSplash,
      props: true
    }
  ]
}
